// 自动读取 routes/modules 的路由表
export function importRoutes() {
  const globEagerRoutes = import.meta.globEager('../routes/modules/*.{ts,js}')
  const routeList: any = []
  Object.keys(globEagerRoutes).forEach((fileName: any) => {
    const route = globEagerRoutes[fileName]
    routeList.push(route.default || route)
  })
  return routeList
}
